export const Galary = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <g clipPath="url(#clip0_2730_14829)">
      <path
        d="M5.56104 6.26781C5.42174 6.12842 5.25634 6.01784 5.07429 5.9424C4.89224 5.86696 4.69711 5.82812 4.50004 5.82812C4.30298 5.82812 4.10785 5.86696 3.9258 5.9424C3.74374 6.01784 3.57834 6.12842 3.43904 6.26781L0.019043 9.6878C0.0652733 10.3149 0.346497 10.9013 0.806479 11.33C1.26646 11.7586 1.8713 11.9979 2.50004 11.9998H9.50004C9.9899 11.9997 10.4688 11.8548 10.8765 11.5833L5.56104 6.26781Z"
        fill="#CFCDD6"
      />
      <path
        d="M9 4C9.55228 4 10 3.55228 10 3C10 2.44772 9.55228 2 9 2C8.44772 2 8 2.44772 8 3C8 3.55228 8.44772 4 9 4Z"
        fill="#CFCDD6"
      />
      <path
        d="M9.5 0H2.5C1.8372 0.000793929 1.20178 0.264441 0.73311 0.73311C0.264441 1.20178 0.000793929 1.8372 0 2.5L0 8.293L2.732 5.561C2.96416 5.32878 3.23978 5.14458 3.54314 5.0189C3.8465 4.89322 4.17164 4.82853 4.5 4.82853C4.82836 4.82853 5.1535 4.89322 5.45686 5.0189C5.76022 5.14458 6.03585 5.32878 6.268 5.561L11.5835 10.8765C11.855 10.4688 11.9999 9.98986 12 9.5V2.5C11.9992 1.8372 11.7356 1.20178 11.2669 0.73311C10.7982 0.264441 10.1628 0.000793929 9.5 0ZM9 5C8.60444 5 8.21776 4.8827 7.88886 4.66294C7.55996 4.44318 7.30362 4.13082 7.15224 3.76537C7.00087 3.39991 6.96126 2.99778 7.03843 2.60982C7.1156 2.22186 7.30608 1.86549 7.58579 1.58579C7.86549 1.30608 8.22186 1.1156 8.60982 1.03843C8.99778 0.961259 9.39991 1.00087 9.76537 1.15224C10.1308 1.30362 10.4432 1.55996 10.6629 1.88886C10.8827 2.21776 11 2.60444 11 3C11 3.53043 10.7893 4.03914 10.4142 4.41421C10.0391 4.78929 9.53043 5 9 5Z"
        fill="#CFCDD6"
      />
    </g>
    <defs>
      <clipPath id="clip0_2730_14829">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
